import React from "react";
import { Button, Icon, Modal } from "../";

const PaymentsHowItWorksModal = ({ isOpen, onClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Online Payments - How it works"
      maxWidth="max-w-2xl"
    >
      <div className="space-y-4">
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0">
            <div className="text-info flex h-8 w-8 items-center justify-center rounded-full bg-[var(--info-bg)]">
              <Icon name="Info" className="h-5 w-5" />
            </div>
          </div>
          <div className="flex-1">
            <h3 className="text-foreground mb-2 text-lg font-medium">
              Connect Stripe to enable online payments
            </h3>
            <p className="text-muted-foreground leading-relaxed">
              Press connect with stripe to start the configuration with your
              stripe account. Follow the steps and fill all the information
              required. Once completed, you will be ready to receive card
              payments
            </p>
            <p className="text-muted-foreground mt-3 leading-relaxed">
              <span className="text-foreground font-medium">Note:</span> If the
              configuration is not completed or any information is missing, the
              dashboard will show you the required actions. Please follow the
              instructions that appears in the required steps section and press
              the Fix in stripe button to make the required changes. Once
              completed, it can take some minutes for the dashboard to update
              the status. You can use the refresh button to update it
            </p>
          </div>
        </div>

        <div className="flex justify-end space-x-3 pt-4">
          <Button
            type="button"
            aria-label="Close how it works modal"
            onClick={onClose}
            emphasis="outline"
            intent="neutral"
            className="rounded-md px-4 py-2 text-sm font-medium"
          >
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default PaymentsHowItWorksModal;
